import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Combobox, ComboboxGroup, Input, Tooltip } from '@node-space/ui-components'
import { BUSINESS_CUSTOMER_DEFAULT_FORM_DATA } from '../helpers/form'
import { BusinessCustomerFormData, ConfirmBusinessCustomerMethod } from '../helpers/types'
import { useBusinessCustomerForm } from '../hooks/useBusinessCustomerForm'
import { AddCustomerActions } from './AddCustomerActions'

export interface AddBusinessCustomerProps {
  defaultValues: BusinessCustomerFormData
  onConfirm: ConfirmBusinessCustomerMethod
  onCancel: () => void
}

export const AddBusinessCustomer = ({
  defaultValues,
  onConfirm,
  onCancel,
}: AddBusinessCustomerProps) => {
  const { t } = useTranslation()
  const { formFields, displayData, hasErrors, handleSubmit } = useBusinessCustomerForm(
    defaultValues ?? BUSINESS_CUSTOMER_DEFAULT_FORM_DATA
  )

  const onSubmit = (data: BusinessCustomerFormData) => {
    onConfirm({ data, displayData })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box flexCol gap={16}>
        <Input
          {...formFields?.businessName}
          placeholder={t('embeddedCustomers.businessFormPlaceholder.businessName')}
          testId="business-name"
        />
        <Input
          {...formFields?.businessDescription}
          testId="business-description"
          Tooltip={
            <Tooltip
              type="complex"
              bodyContent={t('embeddedCustomers.businessFormTooltip.businessDescription')}
            />
          }
        />
        <ComboboxGroup {...formFields?.industry} />
        <Combobox {...formFields?.countryOfIncorporation} />
        <Combobox {...formFields?.monthlyExpectedVolumes} />
        <Combobox
          {...formFields?.riskScore}
          Tooltip={<Tooltip type="complex" bodyContent={t('customers.riskScoreTooltip')} />}
        />
        <Combobox
          {...formFields?.useCase}
          Tooltip={<Tooltip type="complex" bodyContent={t('customers.serviceTypeTooltip')} />}
        />
        <Input
          {...formFields?.externalReference}
          testId="business-external-reference"
          optionalText={t('optional')}
          Tooltip={<Tooltip type="complex" bodyContent={t('customers.externalReferenceTooltip')} />}
        />
      </Box>
      <AddCustomerActions onCancel={onCancel} isDisableContinue={hasErrors} />
    </form>
  )
}
